import { memo } from "react";

import styles from "./styles.module.scss";

const ProgressBar = ({ current = 3, total = 8, height = 14 }) => {
  const percentage = Math.min((current / total) * 100, 100);

  return (
    <div className={styles["progress-wrapper"]}>
      <div className={styles["progress-bar"]} style={{ height }}>
        <div
          className={styles["progress-fill"]}
          style={{ width: `${percentage}%` }}
        >
          <span className={styles["progress-text"]}>
            {current}/{total}
          </span>
        </div>
      </div>
    </div>
  );
};

export default memo(ProgressBar);
